<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>적하보험</li>
        <li>알아두실 사항</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>알아두실 사항</h2>
      </div>
    </div>
    <div class="contents">
      <div class="conWrap">
        <div class="conStyle1">
          <p class="tit">보험계약 체결 전 유의사항</p>
          <p class="txt">
            보험계약자 또는 피보험자(보험대상자)는, 보험계약 체결 전에 보험
            상품명, 보험기간, 보험료, 보험료 납입기간, 피보험자(보험대상자)등의
            계약내용을 반드시 확인하시고, 해당 상품의 상품 설명서 및 보험 약관에
            보다 자세한 내용이 기재되어 있으므로 이를 충분히 검토하신 후
            계약하시기 바랍니다.
          </p>

          <p class="tit">보험 계약 전 알릴 의무</p>
          <p class="txt">
            계약자 또는 피보험자(보험대상자)는 보험계약 체결과 관련된 모든
            중요한 사항을 계약이 성립하기 전에 회사에 고지하여야 합니다.
          </p>

          <p class="tit">보험 기간</p>
          <p class="txt">통상 운송기간 동안을 보험기간으로 합니다.</p>

          <p class="tit">보험료 납입기간</p>
          <p class="txt">
            위험개시전 보험료를 납입하여야 합니다. 다만, 별도 납입 유예기간이
            있는 경우에는 그 약정을 따릅니다.
          </p>

          <p class="tit">보험금 지급제한 사항</p>
          <ul class="line">
            <li>
              보험계약자 또는 피보험자가 상당한 주의의 결여 또는 손해방지 의무를
              이행하지 않았을 경우에는 보험금 지급이 제한될 수 있습니다.
            </li>
            <li>
              비행/활주/엔진흡입/계류 등의 사고시 매사고당 기체보험가입금액의
              5%가 보험금 지급에서 공제됩니다. (단, 전손, 추정전손시에는 비적용)
            </li>
          </ul>
          <p class="txt">※ 본 사항은 계약시 조정 가능합니다.</p>

          <p class="tit">만기환급금의 유무</p>
          <p class="txt">
            당해 보험은 순수보장형 상품으로 만기 시 환급금 및 약관 대출 제도가
            없습니다.
          </p>

          <p class="tit">계약변경시 효과</p>
          <p class="txt">
            상품에 따라 담보의 가입이 거절될 수 있으며, 기존 계약과 비교하여
            보험료가 인상되거나 보장내용이 달라질 수 있으므로 기존 계약과 충분히
            검토하신 후 가입을 결정하여 주시기 바랍니다.
          </p>

          <p class="tit">예금자보호 안내</p>
          <ul class="line" v-show="!prodYn">
            <li>
              이 보험계약은 예금자보호법에 따라 해약환급금(또는 만기 시
              보험금)에 기타지급금을 합한 금액이 1인당 “5천만원까지”(본
              보험회사의 여타 보호상품과 합산)보호됩니다. 이와 별도로 본
              보험회사 보호상품의 사고보험금을 합산한 금액이 1인당
              “5천만원까지”보호됩니다. <br />
              다만, 보험계약자 및 보험료 납부자가 법인인 보험계약은
              예금자보호법에 따라 보호되지 않습니다.
            </li>
            <li>
              본 보험회사가 예금 등 채권의 지급정지 후 파산하게 되는 경우,
              예금보험공사가 보험계약자 1인당 해약환급금(또는 만기 시 보험금)에
              기타지급금을 합한 금액 및 사고보험금을 각각 별도로 최고
              5천만원까지 보호합니다.<br />다만, 보험계약자 및 보험료 납부자가
              법인인 보험계약은 예금자보호법에 따라 보호되지 않습니다.
            </li>
            <li>
              이 내용은 예금자보호법 및 관련 법령의 개정에 따라 달라질 수 있음을
              알려드리며, 자세한 내용은 영업점에 비치된 예금자보호 안내 책자
              등을 참고하거나 예금보험공사 (TEL 1588-0037, www.kdic.or.kr)로
              문의하시기 바랍니다.
            </li>
          </ul>
          <img
            src="@/assets/images/image001.png"
            alt="문구"
            v-show="prodYn"
            style="margin-top: 10px" />
          <ul class="line" v-show="prodYn">
            <li>
              이 보험계약은 예금자보호법에 따라 해약환급금(또는 만기 시
              보험금)에 기타지급금을 합한 금액이 1인당 “1억원까지”(본 보험회사의
              여타 보호상품과 합산)보호됩니다. 이와 별도로 본 보험회사
              보호상품의 사고보험금을 합산한 금액이 1인당 “1억원까지”보호됩니다.
              <br />
              다만, 보험계약자 및 보험료 납부자가 법인인 보험계약은
              예금자보호법에 따라 보호되지 않습니다.
            </li>
            <li>
              이 내용은 예금자보호법 및 관련 법령의 개정에 따라 달라질 수 있음을
              알려드리며, 자세한 내용은 영업점에 비치된 예금자보호 안내 책자
              등을 참고하거나 예금보험공사 (TEL 1588-0037, www.kdic.or.kr)로
              문의하시기 바랍니다.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";

const prodYn = ref(false);

const state = reactive({
  sbcpDt: util.formatDate(new Date(), "yyyy-mm-dd"),
});

new Date(state.sbcpDt) >= new Date("2025-09-01")
  ? (prodYn.value = true)
  : (prodYn.value = false);

console.log(prodYn.value);
if (window.location.host == "cargodev.meritzfire.com") {
  prodYn.value = true;
}
</script>

<style></style>
